module.exports = __webpack_public_path__ + "toBride2-we-r-b.d91d1172.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-r-b.jpg
// module id = AMsk
// module chunks = 0